import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { injectTransferOnce } from '@rma/public/generic/util/http';
import { Observable } from 'rxjs';

export interface LocationFooterLink {
  name: string;

  sales: LocationFooterLinkUrl;
  finance: LocationFooterLinkUrl;
  leasing: LocationFooterLinkUrl;
}

export interface LocationFooterLinkUrl {
  agentUrl?: string;
  agencyUrl?: string;
}

@Injectable({
  providedIn: 'root',
})
export class FooterApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);
  private readonly transferOnce = injectTransferOnce();

  public getLocationFooterLinks(): Observable<LocationFooterLink[]> {
    const url = this.rmaApiUrl('v1/Layout/FooterLinks');

    // The footer hydrates after the app is stable, past the HTTP transfer cache, so the response is handed over by hand.
    return this.transferOnce(`footer-links:${url}`, this.httpClient.get<LocationFooterLink[]>(url, { transferCache: false }));
  }
}
